export default class MessageChannel {
  constructor(options) {
    this.options = options
    this.filters = []
    this.observers = new Map()
  }
  addMessageFilter(filter) {
    this.filters.push(filter)
  }
  send(message) {
    /* tslint:disable */
    // console.debug('parent send message', message);
    this.filters.forEach(filter => {
      message = filter.handle(message)
    })
  }
  handle(message) {
    /* tslint:disable */
    // console.debug('parent handle message', message);
    this.filters.forEach(filter => {
      message = filter.handle(message)
    })
    if (this.observers.has(message.type)) {
      this.observers.get(message.type).forEach((handler) => {
        handler(message)
      })
    }
  }
  subscribe(messageType, handler) {
    if (!this.observers.has(messageType)) {
      this.observers.set(messageType, [])
    }
    this.observers.get(messageType).push(handler)
  }
}
